import { getNestedValue } from "../utils";
class Match {
    validate(value, matchField, data) {
        return {
            isValid: value === getNestedValue(matchField, data),
            additionalData: {
                matchField: matchField
            }
        };
    }
}
export default Match;
